import { SinglePermissionModel } from "../models/IPermission";
import { ViewMode } from 'src/app/shared/enums/view-mode.enum';

export function MapSinglePermissionModelToPermissionAdmin(permission: SinglePermissionModel | undefined, id: number, viewMode: number = ViewMode.FullAccess, groupPermission?: number[]) {
    // If open as view only diasable the check box
    let isSelected: boolean = false;
    if (groupPermission) {
       
   
        if (permission) {
            groupPermission.find((specificPermission) => permission?.permissionId == specificPermission) ? isSelected = true : isSelected = false;
        }
    }

    let isViewMode = viewMode === +ViewMode.View ? true : false;
    return {
        Selected: (viewMode !== ViewMode.Add) && isSelected,
        Enabled: (permission?.enabled ?? false) && !isViewMode,
        DisplayName: permission?.permissionDisplayName ?? '',
        Id: id
    };
}